<template>
  <div class="platform-intro-container">
    <!-- 顶部导航栏 -->
    <!-- <Top /> -->

    <!-- 页面头部 Banner -->
    <div class="page-banner">
      <div class="banner-overlay"></div>
      <div class="banner-content">
        <h1>平台动态</h1>
        <p>了解最新平台资讯、活动与行业动态</p>
      </div>
    </div>

    <!-- 核心内容区 -->
    <div class="container intro-content">
      <!-- 平台公告 -->
      <section class="intro-section">
        <h2 class="section-title">平台公告</h2>
        <div class="news-list">
          <div v-for="item in noticeList" :key="item.id" class="news-item">
            <div class="news-date">{{ item.date }}</div>
            <div class="news-content">
              <h3 class="news-title">{{ item.title }}</h3>
              <p class="news-desc">{{ item.desc }}</p>
            </div>
          </div>

          <!-- 空状态 -->
          <div v-if="noticeList.length === 0" class="empty-state">
            <div class="empty-icon">📢</div>
            <p>暂无平台公告，敬请期待</p>
          </div>
        </div>
      </section>

      <!-- 活动资讯 -->
      <section class="intro-section">
        <h2 class="section-title">活动资讯</h2>
        <div class="news-list">
          <div v-for="item in activityList" :key="item.id" class="news-item">
            <div class="news-date">{{ item.date }}</div>
            <div class="news-content">
              <h3 class="news-title">{{ item.title }}</h3>
              <p class="news-desc">{{ item.desc }}</p>
              <div class="activity-tag" v-if="item.status === 'ongoing'">进行中</div>
              <div class="activity-tag expired" v-if="item.status === 'expired'">已结束</div>
            </div>
          </div>

          <!-- 空状态 -->
          <div v-if="activityList.length === 0" class="empty-state">
            <div class="empty-icon">🎉</div>
            <p>暂无活动资讯，敬请期待</p>
          </div>
        </div>
      </section>

      <!-- 行业动态 -->
      <section class="intro-section">
        <h2 class="section-title">行业动态</h2>
        <div class="news-list">
          <div v-for="item in industryList" :key="item.id" class="news-item">
            <div class="news-date">{{ item.date }}</div>
            <div class="news-content">
              <h3 class="news-title">{{ item.title }}</h3>
              <p class="news-desc">{{ item.desc }}</p>
            </div>
          </div>

          <!-- 空状态 -->
          <div v-if="industryList.length === 0" class="empty-state">
            <div class="empty-icon">📊</div>
            <p>暂无行业动态，敬请期待</p>
          </div>
        </div>
      </section>
    </div>

    <!-- 底部导航 -->
    <!-- <Bottom /> -->
  </div>
</template>

<script>
import Top from '../../components/Header.vue';
import Bottom from '../../components/Footer.vue';

export default {
  name: 'PlatformNews',
  components: {
    Top,
    Bottom
  },
  data() {
    return {
      // 平台公告列表
      noticeList: [
        {
          id: 1,
          date: '2026-03-10',
          title: '平台新版上传功能上线，支持更多3D模型格式',
          desc: '本次更新新增GLB/GLTF格式支持，优化模型预览体验，上传速度提升50%。'
        },
        {
          id: 2,
          date: '2026-02-18',
          title: '平台用户协议与隐私政策更新公告',
          desc: '根据最新法律法规要求，平台对用户协议和隐私政策进行了优化调整，于2026年2月20日正式生效。'
        },
        {
          id: 3,
          date: '2026-01-05',
          title: '平台服务器升级维护通知',
          desc: '为提升服务稳定性，平台将于2026年1月8日0:00-6:00进行服务器升级，期间可能出现短暂访问异常。'
        }
      ],
      // 活动资讯列表
      activityList: [
        // {
        //   id: 1,
        //   date: '2026-03-15',
        //   title: '2026年度3D模型创作大赛正式启动',
        //   desc: '大赛设置万元奖金池，面向所有创作者征集优质3D模型作品，报名截止日期2026年4月30日。',
        //   status: 'ongoing'
        // },
        // {
        //   id: 2,
        //   date: '2026-01-20',
        //   title: '春节创作者福利活动圆满结束',
        //   desc: '本次活动共发放创作激励50万元，覆盖1200名创作者，感谢所有用户的积极参与。',
        //   status: 'expired'
        // },
        // {
        //   id: 3,
        //   date: '2025-12-01',
        //   title: '平台首届数字孪生模型交流会成功举办',
        //   desc: '本次交流会汇聚行业专家50余人，共同探讨3D模型在数字孪生领域的应用与发展。',
        //   status: 'expired'
        // }
      ],
      // 行业动态列表
      industryList: [
        {
          id: 1,
          date: '2026-03-08',
          title: '数字孪生技术入选2026年十大前沿科技趋势',
          desc: '权威机构发布报告显示，数字孪生技术将在智慧城市、工业制造等领域迎来爆发式增长。'
        },
        {
          id: 2,
          date: '2026-02-12',
          title: '3D建模软件市场规模预计2026年突破200亿元',
          desc: '随着元宇宙、虚拟现实等领域的发展，3D建模工具需求持续增长，市场前景广阔。'
        },
        {
          id: 3,
          date: '2026-01-15',
          title: '工信部发布数字资产发展指导意见，利好3D模型行业',
          desc: '意见明确提出支持数字资产交易平台建设，鼓励3D数字内容创作与应用。'
        }
      ]
    };
  }
};
</script>

<style lang="less" scoped>
// 继承全局主题色
@base-deep: #0f1118;
@base-darker: #080a12;
@primary: #0ea5e9;
@primary-light: #38bdf8;
@success: #10b981;
@warning: #f59e0b;
@text-primary: #fff;
@text-secondary: #94a3b8;
@border-color: rgba(148, 163, 184, 0.1);

.platform-intro-container {
  background-color: @base-deep;
  color: @text-primary;
  min-height: 100vh;
}

// 页面Banner
.page-banner {
  position: relative;
  height: 300px;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: url('../../assets/banner/2.png') no-repeat 100% 100%;

  .banner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%239C92AC' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    opacity: 0.5;
  }

  .banner-content {
    position: relative;
    z-index: 2;
    text-align: center;

    h1 {
      font-size: 2.5rem;
      margin-bottom: 1rem;
      text-shadow: 0 3px 15px rgba(14, 165, 233, 0.4);
    }

    p {
      font-size: 1.2rem;
      color: @text-secondary;
      max-width: 600px;
      margin: 0 auto;
    }
  }
}

// 内容容器
.intro-content {
  padding: 3rem 0;
  max-width: 1200px;
  margin: 0 auto;
}

.intro-section {
  margin-bottom: 4rem;
}

.section-title {
  font-size: 2rem;
  color: @primary-light;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid @primary;
  display: inline-block;
}

// 新闻列表样式
.news-list {
  margin-top: 2rem;
}

.news-item {
  display: flex;
  padding: 1.5rem;
  margin-bottom: 1rem;
  background-color: @base-darker;
  border: 1px solid @border-color;
  border-radius: 8px;
  transition: all 0.3s ease;

  &:hover {
    border-color: @primary;
    box-shadow: 0 4px 12px rgba(14, 165, 233, 0.1);
  }

  .news-date {
    min-width: 120px;
    width: 120px;
    font-size: 1.1rem;
    color: @primary-light;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid @border-color;
    margin-right: 1.5rem;
  }

  .news-content {
    flex: 1;

    .news-title {
      font-size: 1.2rem;
      color: @text-primary;
      margin-bottom: 0.5rem;
    }

    .news-desc {
      color: @text-secondary;
      line-height: 1.6;
      margin-bottom: 0.5rem;
    }

    .activity-tag {
      display: inline-block;
      padding: 0.2rem 0.6rem;
      background-color: @success;
      color: #fff;
      border-radius: 4px;
      font-size: 0.9rem;

      &.expired {
        background-color: @warning;
      }
    }
  }
}

// 空状态样式
.empty-state {
  text-align: center;
  padding: 4rem 0;
  color: @text-secondary;

  .empty-icon {
    font-size: 4rem;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1.2rem;
  }
}

// 响应式适配
@media (max-width: 768px) {
  .page-banner {
    height: 200px;

    .banner-content h1 {
      font-size: 1.8rem;
    }

    .banner-content p {
      font-size: 1rem;
    }
  }

  .section-title {
    font-size: 1.5rem;
  }

  .news-item {
    flex-direction: column;

    .news-date {
      min-width: auto;
      width: auto;
      border-right: none;
      border-bottom: 1px solid @border-color;
      margin-right: 0;
      margin-bottom: 1rem;
      padding-bottom: 0.5rem;
    }
  }
}
</style>